var api = require("!../../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../../node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../../../../../node_modules/postcss-loader/src/index.js!./index.global.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = function (style) {
  window.__debugMoverAppStyles && console.log('[DEBUG] INSERTING STYLE', style);
  var target = window.document.head;
  window.__mover_app_styles = window.__mover_app_styles || [];
  var css;
  target.appendChild(style);

  window.__mover_app_styles.push({
    turnOn: function () {
      style.textContent = css;
    },
    turnOff: function () {
      css = style.textContent;
      style.textContent = '';
    },
    style,
  });
};
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};